import { memo } from "react";
import FaqFeaturedArticle from "app/pages/Faq/FaqHome/FaqFeaturedArticles/FaqFeaturedArticle";
import PropTypes from "prop-types";
import "./FaqFeaturedArticles.scss";
import { FormattedMessage } from "react-intl";
import flatMapDeep from "lodash/flatMapDeep";

const FaqFeaturedArticles = ({
	faqCategories = [],
	title,
	handleArticleClick = () => {},
	target,
}) => {
	const allArticles = flatMapDeep(
		faqCategories.map(category =>
			category.subCategories.map(subCategory =>
				subCategory.articles.map(article => ({
					categoryID: category.id,
					subCategoryID: subCategory.id,
					articleID: article.id,
					"categories.lvl1": `${category.name} > ${subCategory.name}`,
					...article,
				}))
			)
		)
	);

	const hits = allArticles.filter(article => Boolean(article.featured));

	return (
		hits.length > 0 && (
			<div className="faq-home__featured-articles">
				<div className="faq-featured-articles" data-testid="faq-featured-articles">
					<div className="faq-featured-articles__title">
						{title ? title : <FormattedMessage id="faq.home.feature.article.title" />}
					</div>

					<div className="faq-featured-articles__list">
						{hits.map((hit = {}) => {
							const articleLink = `/faq/category/${hit.categoryID}/subcategory/${
								hit.subCategoryID
							}/article/${hit.articleID}`;

							return (
								<div key={hit.objectID} className="faq-featured-articles__item">
									<FaqFeaturedArticle
										articleName={hit.title}
										articleContent={hit.content}
										breadcrumb={hit["categories.lvl1"]}
										articleLink={articleLink}
										handleClick={handleArticleClick}
										target={target}
									/>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		)
	);
};

FaqFeaturedArticles.propTypes = {
	faqCategories: PropTypes.array,
	handleArticleClick: PropTypes.func,
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	target: PropTypes.string,
};

export default memo(FaqFeaturedArticles);
